import { EN_UI, type UiMessages } from './en/ui.ts'
import { IT_UI } from './it/ui.ts'
import { locale } from './locale.ts'

/**
 * The interface strings of the active language.
 *
 * Exported as a plain object and not behind a hook: the locale is resolved once at boot
 * (`locale.ts`), so the ~160 call sites read `messages.club.title` exactly as they did when
 * there was a single language.
 */
export const messages: UiMessages = locale === 'en' ? EN_UI : IT_UI
